import type { Ref } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import capitalMarketsService, { type FilterFinancingsRequest } from '../services/capitalMarketsService';

interface UseFilterFinancingsParams extends FilterFinancingsRequest {
  page: number;
  size: number;
}

export default function useFilterFinancings(params: Ref<UseFilterFinancingsParams>) {
  return useQuery({
    queryFn: () => {
      const { page, size, ...filterParams } = params.value;
      return capitalMarketsService.filterFinancings(filterParams, page, size);
    },
    queryKey: ['financings', 'filter', params],
    retry: 2,
    retryDelay: 1000,
  });
}
